import { Header } from '../components/Header'
import { Footer } from '../components/Footer'

export const TermsOfService: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20 pb-16">
        <div className="max-w-4xl mx-auto px-4 py-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Regulamin Serwisu</h1>

          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Postanowienia ogólne</h2>
              <p className="text-gray-600 mb-4">
                Niniejszy Regulamin określa zasady korzystania z serwisu nazwolab.pl prowadzonego przez
                AI SOFTWARE SYSTEMS sp. z o.o., zwanej dalej "Usługodawcą".
              </p>
              <p className="text-gray-600 mb-4">
                Korzystanie z serwisu oznacza akceptację niniejszego Regulaminu w całości.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Definicje</h2>
              <ul className="list-disc list-inside text-gray-600 mb-4 space-y-2">
                <li><strong>Serwis</strong> - strona internetowa nazwolab.pl wraz z wszystkimi usługami</li>
                <li><strong>Użytkownik</strong> - osoba korzystająca z serwisu</li>
                <li><strong>Konto</strong> - profil użytkownika w serwisie</li>
                <li><strong>Usługi Premium</strong> - płatne funkcjonalności serwisu</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Zasady korzystania</h2>
              <h3 className="text-xl font-medium text-gray-800 mb-2">3.1. Ogólne zasady</h3>
              <ul className="list-disc list-inside text-gray-600 mb-4 space-y-2">
                <li>Serwis przeznaczony jest do legalnego użytku</li>
                <li>Zakazane jest nadużywanie zasobów serwisu</li>
                <li>Użytkownik zobowiązuje się do podawania prawdziwych danych</li>
                <li>Zakazane jest wykorzystywanie serwisu do celów nielegalnych</li>
              </ul>

              <h3 className="text-xl font-medium text-gray-800 mb-2">3.2. Ograniczenia użytkowania</h3>
              <ul className="list-disc list-inside text-gray-600 mb-4 space-y-2">
                <li>Plan darmowy: maksymalnie 3 generacje domen</li>
                <li>Plan Basic: maksymalnie 100 generacji miesięcznie</li>
                <li>Plan Enterprise: generacje bez ograniczeń</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Rejestracja i konto użytkownika</h2>
              <p className="text-gray-600 mb-4">
                Korzystanie z pełnej funkcjonalności serwisu wymaga założenia konta użytkownika.
                Użytkownik zobowiązuje się do:
              </p>
              <ul className="list-disc list-inside text-gray-600 mb-4 space-y-2">
                <li>Podawania prawdziwych danych osobowych</li>
                <li>Aktualizowania danych w przypadku zmian</li>
                <li>Zachowania poufności danych logowania</li>
                <li>Niezwłocznego powiadomienia o nieautoryzowanym dostępie</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Usługi płatne</h2>
              <h3 className="text-xl font-medium text-gray-800 mb-2">5.1. Zasady płatności</h3>
              <ul className="list-disc list-inside text-gray-600 mb-4 space-y-2">
                <li>Ceny obejmują podatek VAT</li>
                <li>Płatności realizowane są przez zewnętrznych dostawców płatności</li>
                <li>Dostęp do usług premium następuje po zaksięgowaniu płatności</li>
              </ul>

              <h3 className="text-xl font-medium text-gray-800 mb-2">5.2. Odstąpienie od umowy</h3>
              <p className="text-gray-600 mb-4">
                Konsument ma prawo odstąpienia od umowy w terminie 14 dni od daty zawarcia umowy
                bez podania przyczyny, zgodnie z przepisami Ustawy o prawach konsumenta.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Odpowiedzialność</h2>
              <h3 className="text-xl font-medium text-gray-800 mb-2">6.1. Wyłączenia odpowiedzialności</h3>
              <ul className="list-disc list-inside text-gray-600 mb-4 space-y-2">
                <li>Usługodawca nie gwarantuje ciągłości działania serwisu</li>
                <li>Nie ponosimy odpowiedzialności za dostępność zewnętrznych domen</li>
                <li>Sugestie AI mają charakter pomocniczy i nie stanowią gwarancji</li>
                <li>Użytkownik korzysta z serwisu na własną odpowiedzialność</li>
              </ul>

              <h3 className="text-xl font-medium text-gray-800 mb-2">6.2. Ograniczenie odpowiedzialności</h3>
              <p className="text-gray-600 mb-4">
                Odpowiedzialność Usługodawcy jest ograniczona do wysokości opłat uiszczonych
                przez Użytkownika w ciągu 12 miesięcy poprzedzających zdarzenie.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Własność intelektualna</h2>
              <p className="text-gray-600 mb-4">
                Wszystkie materiały dostępne w serwisie, w tym algorytmy AI, interfejs użytkownika,
                teksty i grafiki są chronione prawem autorskim i stanowią własność Usługodawcy.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Rozwiązywanie sporów</h2>
              <p className="text-gray-600 mb-4">
                Wszelkie spory będą rozstrzygane przez sądy polskie według prawa polskiego.
                Konsumenci mogą skorzystać z platformy ODR:
                <a href="https://ec.europa.eu/consumers/odr/" className="text-blue-600 hover:text-blue-800 ml-1">
                  https://ec.europa.eu/consumers/odr/
                </a>
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Pliki cookies</h2>
              <div className="bg-blue-50 p-6 rounded-lg mb-4">
                <h3 className="text-lg font-semibold text-blue-800 mb-3">Informacja o cookies</h3>
                <p className="text-blue-700 mb-3">
                  Strona używa plików cookies w celach analitycznych i marketingowych.
                  Kontynuując korzystanie ze strony wyrażasz zgodę na ich używanie.
                </p>
                <p className="text-blue-600 text-sm">
                  Szczegółowe informacje o cookies znajdują się w naszej
                  <a href="/privacy" className="text-blue-600 hover:text-blue-800 underline ml-1">Polityce Prywatności</a>.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Informacje konsumenckie</h2>
              <div className="bg-green-50 p-6 rounded-lg mb-4">
                <h3 className="text-lg font-semibold text-green-800 mb-3">Prawa konsumenta</h3>
                <p className="text-green-700 mb-3">
                  W przypadku zakupu usług online, konsument ma prawo do odstąpienia od umowy
                  w terminie 14 dni bez podania przyczyny.
                </p>
                <p className="text-green-700 mb-3">
                  Formularz odstąpienia będzie dostępny na stronie:
                  <a href="/withdrawal" className="text-green-600 hover:text-green-800 underline ml-1">tutaj</a>.
                </p>
                <h4 className="font-semibold text-green-800 mb-2">Rozstrzyganie sporów</h4>
                <p className="text-green-700">
                  W przypadku sporów konsumenckich możliwe jest skorzystanie z platformy ODR:
                  <a href="https://ec.europa.eu/consumers/odr/" className="text-green-600 hover:text-green-800 underline ml-1">
                    https://ec.europa.eu/consumers/odr/
                  </a>
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Informacja RODO</h2>
              <div className="bg-yellow-50 p-6 rounded-lg mb-4">
                <h3 className="text-lg font-semibold text-yellow-800 mb-3">Przetwarzanie danych osobowych</h3>
                <p className="text-yellow-700 mb-2">
                  Administratorem danych osobowych jest AI SOFTWARE SYSTEMS sp. z o.o.
                </p>
                <p className="text-yellow-700 mb-2">
                  Dane przetwarzamy w celach marketingowych na podstawie prawnie uzasadnionego interesu.
                </p>
                <p className="text-yellow-700 mb-3">
                  Przysługuje Pani/Panu prawo dostępu, sprostowania, usunięcia danych oraz wniesienia skargi do UODO.
                </p>
                <p className="text-yellow-600 text-sm">
                  Pełne informacje w
                  <a href="/gdpr" className="text-yellow-600 hover:text-yellow-800 underline ml-1">Informacji RODO</a>
                  oraz <a href="/privacy" className="text-yellow-600 hover:text-yellow-800 underline ml-1">Polityce Prywatności</a>.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. Postanowienia końcowe</h2>
              <p className="text-gray-600 mb-4">
                Usługodawca zastrzega sobie prawo do zmiany niniejszego Regulaminu.
                Zmiany wchodzą w życie po 7 dniach od opublikowania na stronie serwisu.
              </p>
              <p className="text-gray-600 mb-4">
                Regulamin obowiązuje od dnia 14 września 2025 roku.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}